import { Box } from "@chakra-ui/react";

const ContainerBox = ({
  children,
  Style = "",
  bgColor = "bg-white",
  heightAuto,
}) => {
  return (
    <Box
      className={` w-full py-4 flex flex-col gap-4 ${
        heightAuto ? "" : "min-h-[250px]"
      } ${Style} ${bgColor}`}
    >
      {children}
    </Box>
  );
};

export default ContainerBox;
